export const AUTH_TOKEN = "auth_token";
export const TWO_FA_STATUS = "two_fa_status";

export const MESSAGE_CODE_2FA_REQUIRED = 1410;

export const ROLES = {
  ORG_ADMIN: "org_admin",
  ORG_USER: "org_user",
};
